var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col col-span-full sm:col-span-6 xl:col-span-4 bg-white dark:bg-gray-800 shadow-xs rounded-md"},[_c('div',{},[_c('div',{staticClass:"pt-12"}),_c('div',{staticClass:"ml-8 mt-8 mb-8"},[_c('ChangePassword')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }